'use client';

import { useEffect, useState } from 'react';
import { fetchRemoteConfig } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import {
    DEFAULT_COMPANY_SETUP_COUNTRIES,
    type CompanySetupCountry
} from '@/hotdesk-ui/constants/company-setup.constant';
import { parseCompanySetupCountries } from '@/hotdesk-ui/helpers/company-setup-content';

/**
 * Company Setup countries from Remote Config (`company_setup_countries`).
 * Starts from the bundled default and swaps in the RC list once fetched; a
 * missing or invalid value keeps the default.
 */
export const useCompanySetupCountries = (): CompanySetupCountry[] => {
    const [countries, setCountries] = useState(DEFAULT_COMPANY_SETUP_COUNTRIES);

    useEffect(() => {
        let cancelled = false;
        fetchRemoteConfig(RemoteConfigKeys.COMPANY_SETUP_COUNTRIES, 'string')
            .then((value) => {
                const parsed = parseCompanySetupCountries(value);
                if (parsed && !cancelled) setCountries(parsed);
            })
            .catch(() => undefined);
        return () => {
            cancelled = true;
        };
    }, []);

    return countries;
};
